<template>
  <!-- Template per Browse cards & Carousel Cards -->
  <div v-if="type == 'simpleCarousel'" :class="type">
    <div v-if="content.image != null" class="imgContainer">
      <font-awesome-icon @click="openPicture(content.image.url)" icon="search" class="openPic" />
      <img :src="content.image.url" />
    </div>
    <div class="textContainer" @click="sendMessage(content.title)">
      <h4>{{ content.title }}</h4>
      <h6>{{ content.subtitle }}</h6>
      <p>{{ content.text }}</p>
    </div>
    <div v-if="content.link != null" class="linkContainer">
      <a target="_blank" :href="content.link">
        <font-awesome-icon icon="arrow-right" />
        {{ content.linktext }}
      </a>
    </div>
  </div>

  <!-- Template per Media Card -->
  <div v-else-if="type == 'mediacard'" class="message outgoing-message embedcard">
    <div class="mediaContainer">
      <font-awesome-icon
        v-if="(content.type == 'online_photo') || (content.type == 'photo')"
        @click="openPicture(content.item.media)"
        icon="search"
        class="openPic"
      />
      <img v-if="content.type == 'online_photo'" class="embedimage" :src="content.item.media" />
      <img
        v-if="content.type == 'photo'"
        class="embedimage"
        :src="require(`@/assets/media/${content.item.media}`)"
      />
      <iframe
        v-if="content.type == 'online_video'"
        :src="content.item.media"
        frameborder="0"
        allowfullscreen
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
      <video v-if="content.type == 'video'" controls>
        <source :src="require(`@/assets/media/${content.item.media}`)" type="video/mp4" />
      </video>
      <audio v-if="content.type == 'audio'" controls>
        <source :src="require(`@/assets/media/${content.item.media}`)" type="audio/mpeg" />
      </audio>
    </div>
    <div class="textContainer">
      <h5>{{content.item.title}}</h5>
      <p>{{content.item.subtitle}}</p>
    </div>
    <div v-if="content.item.link != null" :class="{youtube: isYoutube}" class="linkContainer">
      <a target="_blank" :href="content.item.link">
        <font-awesome-icon icon="arrow-right" />
        {{ content.item.linktext }}
      </a>
    </div>
  </div>
  <!-- .message embedcard -->

  <!-- Template per Simple Cards  & Browsercards-->
  <div
    v-else
    class="outgoing-message message botcard"
    :class="{browsecard: type == 'browserCarousel'}"
  >
    <div v-if="content.image.url != null" class="imgContainer">
      <font-awesome-icon @click="openPicture(content.image.url)" icon="search" class="openPic" />
      <img :src="content.image.url" />
    </div>
    <div class="textContainer">
      <h4 v-html="content.title"></h4>      
      <p v-html="content.description"></p>
    </div>
    <div class="linkContainer">
      <span>
        <a target="_blank" :href="content.button.url">
          <font-awesome-icon icon="arrow-right" />
          {{ content.button.text }}
        </a>
      </span>
    </div>
  </div>

  <!-- .card -->
</template>
<script>
export default {
  name: "card",
  props: ["content", "type"],
  data() {
    return {
      isLink: true,
      isYoutube: false
    };
  },
  methods: {
    sendMessage: function(message) {
      this.$root.$emit("component_message", message);
    },
    openPicture: function(url) {
      if (this.content.type == "online_photo") {
        window.open(url);
      } else {
        window.open(url);
      }
    }
  },
  mounted() {
    if (this.type == "mediacard") {
      if (this.content.item.media == null) this.isLink = false;
      if (this.content.item.media.indexOf("youtube") > -1)
        this.isYoutube = true;
    }
  }
};
</script>
<style>
.openPic {
  position: absolute;
  right: 5px;
  bottom: 5px;
  color: #fff;
  cursor: pointer;
}

/**** Simple Card ****/
.botcard {
  border-radius: 25px !important;
}
.botcard:after {
  content: "";
  display: none;
}
.botcard .imgContainer {
  margin: -4px -14px 0;
  overflow: hidden;
  border-radius: 25px 25px 0 0;
  height: 32vh;
  position: relative;
}
.botcard .imgContainer img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.botcard .textContainer {
  padding: 13px 6px;
}
.linkContainer {
  margin-left: -14px;
  margin-right: -14px;
  padding: 12px 23px;
}
.linkContainer.disabled {
  display: none;
}
.linkContainer a i {
  margin-right: 10px;
}
/*** Carouselcard ****/
.carouselcards {
  clear: both;
  margin-bottom: 52px;
}
.carouselcards .slick-list {
  margin: -10px;
}
.carouselcards .slick-slide {
  margin-right: 15px;
}
.carouselcards .slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
}
.carouselcards .slick-dots li {
  position: relative;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.carouselcards .slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 12px;
  height: 12px;
  padding: 5px;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  border-radius: 50%;
}
.slick-dots li.slick-active button:before {
  font-family: "slick";
  font-size: 33px;
  line-height: 12px;
  position: absolute;
  top: 0;
  left: -4px;
  width: 20px;
  height: 20px;
  content: "•";
  text-align: center;
  -webkit-font-smoothing: antialiased;
}
.carouselcards .simpleCarousel {
  background: #ebebeb;
  border-radius: 25px;
  width: 200px;
  padding: 4px 14px;
  margin: 0 0.5em;
}
.carouselcards .simpleCarousel .imgContainer {
  overflow: hidden;
  border-radius: 25px 25px 0 0;
  height: 20vh;
  margin: -4px -14px 0;
  position: relative;
}
.carouselcards .simpleCarousel .textContainer {
  padding-top: 9px;
}
.carouselcards .simpleCarousel img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.carouselcards .simpleCarousel h4 {
  margin-top: 0.5em;
  font-size: 120%;
}
.browsecards {
  clear: both;
  margin-bottom: 52px;
}
.browsecards .slick-list {
  margin: -10px;
}
.browsecards .slick-slide {
  margin-right: 15px;
}
.browsecards .slick-dots {
  position: absolute;
  bottom: -25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;
}
.browsecards .slick-dots li {
  position: relative;
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.browsecards .slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 12px;
  height: 12px;
  padding: 5px;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  border-radius: 50%;
}
.browsecards .slick-dots li.slick-active button:before {
  font-family: "slick";
  font-size: 33px;
  line-height: 12px;
  position: absolute;
  top: 0;
  left: -4px;
  width: 20px;
  height: 20px;
  content: "•";
  text-align: center;
  -webkit-font-smoothing: antialiased;
}
.browsecards .browsecard {
  float: left;
  background: #ebebeb;
  border-radius: 25px;
  width: 305px;
  padding: 4px 14px;
  margin: 0 0.5em;
}
.browsecards .browsecard .imgContainer {
  overflow: hidden;
  border-radius: 25px 25px 0 0;
  height: 30vh;
  margin: -4px -14px 0;
  position: relative;
}
.browsecards .browsecard img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.botcard p {
  font-size: 0.85em;
}
.browsecards .browsecard h4 {
  margin-top: 0.5em;
}
.browsecards .slick-dots li button {
  background: transparent;
  border: 0.5px solid #97bf0d !important;
}
.browsecards .slick-dots li.slick-active button:before {
  opacity: 0.5;
  color: #97bf0d;
}
.browsecards .browsecard .linkContainer a {
  color: #97bf0d;
}
.embedcard {
  border-top-left-radius: 25px !important;
}
.embedcard::after {
  display: none;
}
.embedcard .mediaContainer {
  margin: -4px -14px 0;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
  overflow: hidden;
  position: relative;
}
.embedcard .mediaContainer iframe,
.embedcard .mediaContainer video {
  display: block;
  width: 100%;
  height: 100%;
}
.embedcard h5 {
  margin-top: 0.7em;
  margin-bottom: 2px;
}
.embedcard h4 {
  font-size: 1.1em;
  font-weight: 400;
}
.embedcard .linkContainer a {
  padding: 4px 7px 7px;
  border-radius: 7px;
}
.embedcard .linkContainer {
  border-top: 1px solid #d6d6d6;
  margin: 0 -14px;
  text-align: center;
}

.embedcard .linkContainer a:hover {
  text-decoration: none;
}
.embedcard .mediaContainer {
  max-height: 380px;
}
.embedcard .mediaContainer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.message.browsecard,
.message.carouselcards {
  max-width: 100%;
}
</style>